import { Outlet } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { AppHeader } from "./AppHeader";

export const AppLayout = () => {
  const { isAuthenticated, isLoading } = useAuth();
  const showHeader = isAuthenticated && !isLoading;

  return (
    <>
      {showHeader && <AppHeader />}
      <Outlet />
    </>
  );
};
